module.exports = __webpack_public_path__ + "static/media/Invalid.7507d24c.svg";